import { LessonProblem, StudentProblemResult } from '@yandex-int/k-common';
import { Switch, Text } from 'platform-components';
import React from 'react';
import { useDispatch } from 'react-redux';
import { accessibleClick } from '@edu-frontend/modules/src/shared/lib/a11y';

import { lessonContentActions } from '../../actions';
import { useLessonContentSelector } from '../../selectors';
import { getShouldHideAnswerControls, getShouldShowProblemOverlay } from '../../utils';
import { StatItem } from '../lesson-content__stat-item-wrapper';

import './lesson-content__stat_answer-controls.scss';

interface Props {
    problemLink: LessonProblem;
    studentProblemResult: StudentProblemResult | null;
}

export const AnswerControls = ({ problemLink, studentProblemResult }: Props) => {
    const dispatch = useDispatch();
    const problemId = problemLink.id;
    const showCorrectAnswers = useLessonContentSelector((s) => problemId in s.showCorrectAnswersForProblems);
    const toggleShowCorrectAnswer = () => dispatch(lessonContentActions.toggleShowCorrectAnswer({ problemId }));

    if (getShouldHideAnswerControls(problemLink, studentProblemResult)) {
        return null;
    }

    if (getShouldShowProblemOverlay(problemLink.problem)) {
        return null;
    }

    return (
        <StatItem>
            <span className="lesson-content__stat-answer-controls" {...accessibleClick(toggleShowCorrectAnswer)}>
                <Text id="studentLessonStat.showAnswer" />
            </span>
            <span className="lesson-content__stat-detail-value qa_stat-detail-answer-control">
                <Switch
                    checked={showCorrectAnswers}
                    onChange={toggleShowCorrectAnswer}
                    size={Switch.SIZES.S}
                    theme={Switch.THEMES.LIGHT_BLUE}
                    view={Switch.VIEWS.INVERSE}
                />
            </span>
        </StatItem>
    );
};
